<template>
  <Wrap>
    <UiBreadcrumbsV3 :list="breadcrumbs" />
  </Wrap>
</template>

<script lang="ts" setup>
  import { UiBreadcrumbsV3 } from '@experience/vue3-kit';
  import { computed } from 'vue';

  import Wrap from '@/shared/ui/Wrap.vue';
  import { useScreenSize } from '@/shared/utils/breakpoints';

  const { isMobile } = useScreenSize();

  const breadcrumbs = computed(() =>
    isMobile.value
      ? [
          {
            label: 'Журнал',
            href: '/journal',
          },
          {
            label: 'Автор',
          },
        ]
      : [
          {
            label: 'Журнал',
            href: '/journal',
          },
        ],
  );
</script>
